/**
 * 数据大屏模块路由
 * 路径前缀: /desktopCenter/dataScreen/
 */
import type { RouteRecordRaw } from "vue-router";

export const dataScreenRoutes: RouteRecordRaw[] = [
	{
		path: "/desktopCenter/dataScreen/screenDisplay",
		name: "ScreenDisplay",
		meta: {
			title: "大屏展示",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/datascreen/index",
		},
		component: () => import("@main/views/Apps/DataScreen/ScreenDisplay/ScreenDisplay.vue"),
	},
	{
		path: "/desktopCenter/dataScreen/screenSettings",
		name: "ScreenSettings",
		meta: {
			title: "大屏设置",
			keepAlive: false,
			iframeUrl: "cos.php/wdsxh/config/index",
		},
		component: () => import("@main/views/Apps/DataScreen/ScreenSettings/ScreenSettings.vue"),
	},
];
